import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.99996 4.16699V15.8337M4.16663 10.0003H15.8333",
    stroke: "#344054",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#22c55e",
  class: "w-14"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_6 = { class: "ml-2.5" }
const _hoisted_7 = { class: "text-[#344054] font-semibold text-sm mb-0.5" }
const _hoisted_8 = { class: "text-[#475467] text-xs mb-0.5" }
const _hoisted_9 = { class: "text-[#475467] text-xs" }
const _hoisted_10 = { class: "flex flex-row gap-3 ml-8" }
const _hoisted_11 = { class: "border border-[#D0D5DD] text-sm font-semibold text-[#344054] rounded-lg py-2 px-3" }
const _hoisted_12 = { class: "flex justify-right items-center" }
const _hoisted_13 = { class: "text-[#344054] font-medium border border-[#EAECF0] bg-[#F9FAFB] px-3 px-1 rounded-xl text-sm mr-8" }
const _hoisted_14 = { class: "relative right-[14rem]" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "#98A2B3",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "#98A2B3",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "mt-8 block w-full"
}
const _hoisted_24 = { class: "font-semibold text-[#344054] text-sm mb-6" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "flex gap-8 mb-4" }
const _hoisted_27 = { class: "flex gap-8 mb-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-14 mb-5" }, null, -1)
const _hoisted_29 = { class: "flex w-full justify-end" }
const _hoisted_30 = {
  key: 0,
  class: "inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white me-2",
  role: "status"
}
const _hoisted_31 = {
  key: 1,
  class: "rounded-md bg-green-50 p-4 w-full mt-6"
}
const _hoisted_32 = { class: "flex" }
const _hoisted_33 = { class: "flex-shrink-0" }
const _hoisted_34 = { class: "ml-3" }
const _hoisted_35 = { class: "text-sm font-medium text-green-800" }
const _hoisted_36 = { class: "ml-auto pl-3" }
const _hoisted_37 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Dismiss", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_40 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_41 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13 1L1 13M1 1L13 13",
    stroke: "#98A2B3",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = { class: "flex w-full justify-end mt-8" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 0,
  class: "inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white me-2",
  role: "status"
}
const _hoisted_48 = {
  key: 0,
  class: "rounded-md bg-green-50 p-4 w-full mt-6"
}
const _hoisted_49 = { class: "flex" }
const _hoisted_50 = { class: "flex-shrink-0" }
const _hoisted_51 = { class: "ml-3" }
const _hoisted_52 = { class: "text-sm font-medium text-green-800" }
const _hoisted_53 = { class: "ml-auto pl-3" }
const _hoisted_54 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Dismiss", -1)
const _hoisted_56 = { class: "p-8 relative" }
const _hoisted_57 = { class: "text-center" }
const _hoisted_58 = { class: "text-lg font-semibold text-[##101828] mb-5" }
const _hoisted_59 = { class: "mt-5 text-center" }
const _hoisted_60 = { class: "text-center" }
const _hoisted_61 = { class: "text-sm text-[#475467] mb-8" }
const _hoisted_62 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_63 = {
  key: 0,
  class: "relative ml-2"
}
const _hoisted_64 = { class: "flex" }
const _hoisted_65 = { class: "flex-shrink-0" }
const _hoisted_66 = { class: "ml-3" }
const _hoisted_67 = { class: "ml-auto pl-3" }
const _hoisted_68 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_69 = { class: "sr-only" }

import { ref, computed, watch } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useAdminStore } from "@/stores/adminStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { useFilterStore } from "@/stores/filterStore";
import { FormKitNode } from "@formkit/core";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import {
  TrashIcon,
  XMarkIcon,
} from "@heroicons/vue/24/outline";
import { unionBy } from "lodash";
import { CheckCircleIcon } from "@heroicons/vue/20/solid";

// Define a type for the teacher object
interface Teacher {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  designation: string;
  phoneNumber: string; // Add the phoneNumber property
  assignedClasses: { class: string; subject: string; learnerCount: number }[];
  status: string;
}

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'TeacherDetailsComponent',
  setup(__props) {

const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();
const learnerStore = useLearnerStore();
const adminStore = useAdminStore();
const filterStore = useFilterStore();

// Get school teachers
const schoolTeachers = computed(() => {
  const teachers = schoolStore.currentSchoolStructure?.allClassGroupAdmins || [];

  // Remove any duplicate teachers
  const uniqueTeachers = unionBy(teachers, "_id");

  // Sort the teachers by their full name
  uniqueTeachers.sort((a: any, b: any) => {
    return a.firstName.localeCompare(b.firstName);
  });

  // Update assigned classes for each teacher
  uniqueTeachers.forEach((teacher: any) => {
    teacher.assignedClasses = getAssignedClasses(teacher._id);
    // console.log(teacher, teacher.assignedClasses);
    teacher.groupedClasses = teacher.assignedClasses.reduce((acc: any, assignedClass: any) => {
      if (!acc[assignedClass.subject]) {
        acc[assignedClass.subject] = [];
      }
      acc[assignedClass.subject].push(assignedClass);
      return acc;
    }, {});

    // Sort the groupedClasses by class name
    for (const subject in teacher.groupedClasses) {
      teacher.groupedClasses[subject].sort((a: any, b: any) => {
        return a.class.localeCompare(b.class);
      });
    }
  });

  return uniqueTeachers;
});

// Get assigned classes per teacher
const getAssignedClasses = (teacherId: any) => {
  const classes = schoolStore.currentSchoolStructure?.classGroups || [];
  const assignedClasses: {
    class: string;
    subject: string;
    learnerCount: number;
  }[] = [];

  classes.forEach((classItem) => {
    const admins = classItem.admins || [];
    admins.forEach((admin) => {

      if (admin && String(admin._id) === String(teacherId)) {
        const learnerCount = getLearnerCount(classItem.name);
        assignedClasses.push({
          class: classItem.name,
          subject: classItem.subject,
          learnerCount,
        });
      }
    });
  });

  return assignedClasses;
};

// Get learner count based on class
const getLearnerCount = (className: string) => {
  const learners = learnerStore.getSchoolLearners;
  const filteredLearners = learners.filter((learner) =>
    learner.classes &&
    learner.classes.some((cls) => cls.name === className)
  );
  return filteredLearners.length;
};

// Use teacher ID for toggle functionality
const selectedTeacherId = ref<string | null>("");

const openCurrentTeacher = (teacherId: string) => {
  selectedTeacherId.value =
    selectedTeacherId.value === teacherId ? null : teacherId;
};

const loading = ref<boolean>(false);

const formData = ref({
  firstName: "",
  lastName: "",
  designation: "",
  email: "",
  phoneNumber: "",
});

// Watch the selected teacher and update formData
watch(
  () => selectedTeacherId.value,
  (newTeacherId) => {
    const teacher = schoolTeachers.value.find((t) => t._id === newTeacherId);
    if (teacher) {
      formData.value = {
        firstName: teacher.firstName,
        lastName: teacher.lastName,
        designation: teacher.designation,
        email: teacher.email,
        phoneNumber: teacher.phoneNumber || "",
      };
    }
  }
);

// save method
const saveProgress = async () => {
  try {
    loading.value = true;
    if (selectedTeacherId.value !== null) {
      let request = await schoolStore.updateTeacherDetails(
        selectedTeacherId.value,
        formData.value
      );
    }
    loading.value = false;
    updateSuccess.value = true;
  } catch (error) {
    console.error(error);
    loading.value = false;
    updateSuccess.value = false;
  }
};

const updateSuccess = ref(false);
const saveSuccess = ref(false);

const closeSuccess = () => {
  updateSuccess.value = false;
};

const closeSave = () => {
  saveSuccess.value = false;
  closeModals();
};

// cancel method
const cancelProgress = () => {
  selectedTeacherId.value = null; // Close the current teacher's content
};

// show add teacher modal
const addTeacherModal = ref<boolean>(false);

const addTeacher = () => {
  addTeacherModal.value = true;
};

const closeModals = () => {
  addTeacherModal.value = false;
};

const schoolId = schoolStore.currentSchoolStructure?._id ?? "";

// Reactive object for new teacher data
const newTeacher = ref({
  firstName: "",
  lastName: "",
  designation: "Class Group Admin",
  email: "",
  phoneNumber: "",
  school: schoolId,
});

const buttonIsDisabled = ref(false);

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await schoolStore?.validateEmail(node.value as string);
    buttonIsDisabled.value = emailExists; // Disable button if email exists
    return !emailExists; // Validation passes if email does not exist
  } catch (error) {
    buttonIsDisabled.value = true; // Disable on error
    return true;
  }
};

// save new teacher form
const saveNewTeacher = async () => {
  loading.value = true;
  try {
    let request = await schoolStore.addNewTeacherToSchool(newTeacher.value);
    loading.value = false;
    saveSuccess.value = true;
    if (request === undefined) {
      saveSuccess.value = false;
    }
  } catch (error) {
    console.error(error);
    saveSuccess.value = false;
  }

  // Close modal after saving
  closeModals();

  // Once saved, you can reset the form fields if needed
  newTeacher.value = {
    firstName: "",
    lastName: "",
    designation: "Class Group Admin",
    email: "",
    phoneNumber: "",
    school: schoolId,
  };

  saveSuccess.value = false;
};

const confirmTeacherDeletionModal = ref(false);
const teacherToDelete = ref<Teacher | null>(null);
const deleteTeacherSuccess = ref(false);
const showTeacherDeleteNotification = ref(false);

const showConfirmTeacherDeletionModal = (teacher: Teacher, e: Event) => {
  e.preventDefault();
  confirmTeacherDeletionModal.value = true;
  teacherToDelete.value = teacher;
};

const cancelTeacherDeletion = () => {
  confirmTeacherDeletionModal.value = false;
};

const removeTeacher = async (teacher: Teacher, e: Event) => {
  e.preventDefault();
  deleteTeacherSuccess.value = false;

  const teacherId = teacher._id;

  if (teacherId) {
    const deletedTeacher = await adminStore.deleteClassGroupTeacher(teacherId, filterStore.selectedFilters.school);
    deleteTeacherSuccess.value = deletedTeacher;
    showTeacherDeleteNotification.value = deletedTeacher;
  } else {
    console.error("Teacher ID is undefined");
    deleteTeacherSuccess.value = false;
  }

  confirmTeacherDeletionModal.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: addTeacher,
        class: "text-sm bg-white border border-[#D0D5DD] rounded-lg font-semibold py-2.5 px-4 text-[##344054] flex flex-row gap-1 absolute right-0 top-[-78px]"
      }, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.add_teacher")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolTeachers.value, (teacher) => {
        return (_openBlock(), _createElementBlock("div", {
          key: teacher._id,
          class: "border border-[#EAECF0] rounded-xl p-5 w-full mb-6"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h3", _hoisted_7, _toDisplayString(teacher.firstName) + " " + _toDisplayString(teacher.lastName), 1),
                _createElementVNode("p", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.status")) + ": ", 1),
                  _createElementVNode("strong", null, _toDisplayString(teacher.status), 1)
                ]),
                _createElementVNode("p", _hoisted_9, _toDisplayString(teacher.email), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacher.groupedClasses, (classes, subject) => {
                return (_openBlock(), _createElementBlock("div", { key: subject }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(_unref(subjectStore).getSubjectNameById(subject)), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classes, (classItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: classItem.class,
                        class: "border border-[#D0D5DD] text-sm font-semibold text-[#344054] rounded-lg py-2 px-3"
                      }, [
                        _createElementVNode("p", null, _toDisplayString(classItem.class), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", null, _toDisplayString(teacher.assignedClasses.reduce(
                  (total, assignedClass) => total + assignedClass.learnerCount,
                  0
                )) + " " + _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.students")), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (showConfirmTeacherDeletionModal(teacher, $event)),
                  class: "mt-1 text-red-500"
                }, [
                  _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                ], 8, _hoisted_15)
              ]),
              _createElementVNode("button", {
                onClick: ($event: any) => (openCurrentTeacher(teacher._id))
              }, [
                (selectedTeacherId.value !== teacher._id)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
              ], 8, _hoisted_16)
            ])
          ]),
          (selectedTeacherId.value === teacher._id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.teacher_details")), 1),
                teacher
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_FormKit, {
                        type: "form",
                        id: "login-form",
                        actions: false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_FormKit, {
                              type: "text",
                              label: "Name",
                              modelValue: formData.value.firstName,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.firstName) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_FormKit, {
                              type: "text",
                              label: "Last Name",
                              modelValue: formData.value.lastName,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.lastName) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_FormKit, {
                              type: "text",
                              label: "Position",
                              disabled: "",
                              modelValue: formData.value.designation,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.designation) = $event)),
                              "input-class": "!bg-slate-200 cursor-not-allowed"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_FormKit, {
                              type: "email",
                              label: "Email",
                              modelValue: formData.value.email,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.email) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_FormKit, {
                              type: "text",
                              label: "Phone Number",
                              modelValue: formData.value.phoneNumber,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.phoneNumber) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    onClick: cancelProgress,
                    class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap disabled:opacity-50"
                  }, _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.cancel")), 1),
                  _createElementVNode("button", {
                    onClick: saveProgress,
                    class: "text-white border border-[#155EEF] bg-[#155EEF] text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap disabled:opacity-50"
                  }, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.save_changes")), 1)
                  ])
                ]),
                (updateSuccess.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_unref(CheckCircleIcon), {
                            class: "h-5 w-5 text-green-400",
                            "aria-hidden": "true"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t("admin_screens.alerts.success_updated")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50",
                              onClick: closeSuccess
                            }, [
                              _hoisted_38,
                              _createVNode(_unref(XMarkIcon), {
                                class: "h-5 w-5",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (addTeacherModal.value)
        ? (_openBlock(), _createBlock(_unref(TransitionRoot), {
            key: 0,
            as: "template",
            show: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Dialog), {
                as: "div",
                class: "relative z-50"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_39
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                  onClick: closeModals,
                                  class: "absolute top-4 right-4"
                                }, _hoisted_43),
                                _createElementVNode("div", _hoisted_44, [
                                  _createVNode(_unref(DialogTitle), {
                                    as: "h3",
                                    class: "text-lg font-semibold text-[##101828] mb-5"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.add_teacher")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_FormKit, {
                                    type: "form",
                                    id: "login-form",
                                    actions: false
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormKit, {
                                        type: "text",
                                        label: "Name",
                                        placeholder: "First Name",
                                        "outer-class": "mb-4",
                                        modelValue: newTeacher.value.firstName,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newTeacher.value.firstName) = $event)),
                                        validation: "required"
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_FormKit, {
                                        type: "text",
                                        label: "Last Name",
                                        placeholder: "Last Name",
                                        "outer-class": "mb-4",
                                        modelValue: newTeacher.value.lastName,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newTeacher.value.lastName) = $event)),
                                        validation: "required"
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_FormKit, {
                                        type: "text",
                                        label: "Position",
                                        placeholder: "Position",
                                        "outer-class": "mb-4",
                                        modelValue: newTeacher.value.designation,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newTeacher.value.designation) = $event)),
                                        validation: "required",
                                        disabled: "true"
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_FormKit, {
                                        type: "email",
                                        label: "Email",
                                        placeholder: "Email",
                                        "outer-class": "mb-4",
                                        modelValue: newTeacher.value.email,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newTeacher.value.email) = $event)),
                                        validation: "required|email|(500)email_exists",
                                        "validation-rules": { email_exists: email_exists },
                                        "validation-messages": {
                          email_exists: _ctx.$t(
                            'add_grades_class_component.step_1.email_exists'
                          ),
                        }
                                      }, null, 8, ["modelValue", "validation-rules", "validation-messages"]),
                                      _createVNode(_component_FormKit, {
                                        type: "text",
                                        label: "Phone Number",
                                        placeholder: "+27 (0) 000-0000",
                                        modelValue: newTeacher.value.phoneNumber,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newTeacher.value.phoneNumber) = $event)),
                                        validation: "required"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("button", {
                                  onClick: closeModals,
                                  class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap"
                                }, _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.cancel")), 1),
                                _createElementVNode("button", {
                                  onClick: saveNewTeacher,
                                  disabled: buttonIsDisabled.value,
                                  class: "text-white border border-[#155EEF] bg-[#155EEF] text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap disabled:opacity-50"
                                }, [
                                  (loading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.save_changes")), 1)
                                ], 8, _hoisted_46)
                              ]),
                              (saveSuccess.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, [
                                        _createVNode(_unref(CheckCircleIcon), {
                                          class: "h-5 w-5 text-green-400",
                                          "aria-hidden": "true"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t("admin_screens.alerts.success_saved")), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50",
                                            onClick: closeSave
                                          }, [
                                            _hoisted_55,
                                            _createVNode(_unref(XMarkIcon), {
                                              class: "h-5 w-5",
                                              "aria-hidden": "true"
                                            })
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl',
      open: confirmTeacherDeletionModal.value,
      onLocalModalOpen: _cache[16] || (_cache[16] = ($event: any) => (confirmTeacherDeletionModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("h3", _hoisted_58, _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.add_teacher")), 1)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_FormKit, {
                type: "form",
                id: "login-form",
                actions: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: "Name",
                    placeholder: "First Name",
                    "outer-class": "mb-4",
                    modelValue: newTeacher.value.firstName,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newTeacher.value.firstName) = $event)),
                    validation: "required"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: "Last Name",
                    placeholder: "Last Name",
                    "outer-class": "mb-4",
                    modelValue: newTeacher.value.lastName,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((newTeacher.value.lastName) = $event)),
                    validation: "required"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: "Position",
                    placeholder: "Position",
                    "outer-class": "mb-4",
                    modelValue: newTeacher.value.designation,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((newTeacher.value.designation) = $event)),
                    validation: "required",
                    disabled: "",
                    "input-class": "!bg-slate-200 cursor-not-allowed"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_FormKit, {
                    type: "email",
                    label: "Email",
                    placeholder: "Email",
                    "outer-class": "mb-4",
                    modelValue: newTeacher.value.email,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((newTeacher.value.email) = $event)),
                    validation: "required|email|(500)email_exists",
                    "validation-rules": { email_exists: email_exists },
                    "validation-messages": {
                  email_exists: _ctx.$t(
                    'add_grades_class_component.step_1.email_exists'
                  ),
                }
                  }, null, 8, ["modelValue", "validation-rules", "validation-messages"]),
                  _createVNode(_component_FormKit, {
                    type: "text",
                    label: "Phone Number",
                    placeholder: "+27 (0) 000-0000",
                    modelValue: newTeacher.value.phoneNumber,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((newTeacher.value.phoneNumber) = $event)),
                    validation: "required"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_unref(DialogTitle), {
              as: "h3",
              class: "text-lg font-semibold text-[##101828] mb-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_title")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.delete_teacher_confirm")), 1)
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("button", {
              type: "button",
              class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
              onClick: cancelTeacherDeletion
            }, _toDisplayString(_ctx.$t("internal_tools.school_champions.modal.back")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "text-white border border-[#155EEF] bg-[#155EEF] text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (teacherToDelete.value && removeTeacher(teacherToDelete.value, $event)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_btn")) + " ", 1),
              (_unref(adminStore).loader.deleteAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createVNode(_component_spinner_loader)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    (showTeacherDeleteNotification.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({
        'rounded-md p-4 mt-5': true,
        'bg-green-50': deleteTeacherSuccess.value,
        'bg-red-50': !deleteTeacherSuccess.value,
      })
        }, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(deleteTeacherSuccess.value ? _unref(CheckCircleIcon) : _ctx.ExclamationCircleIcon), {
                class: _normalizeClass({
              'h-5 w-5': true,
              'text-green-400': deleteTeacherSuccess.value,
              'text-red-400': !deleteTeacherSuccess.value,
            }),
                "aria-hidden": "true"
              }, null, 8, ["class"]))
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("p", {
                class: _normalizeClass({
              'text-sm font-medium': true,
              'text-green-800': deleteTeacherSuccess.value,
              'text-red-800': !deleteTeacherSuccess.value,
            })
              }, _toDisplayString(deleteTeacherSuccess.value
                ? _ctx.$t("internal_view.delete_teacher_success")
                : _ctx.$t("internal_view.delete_teacher_error")), 3)
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass({
                'inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2': true,
                'bg-green-50 text-green-500 hover:bg-green-100 focus:ring-green-600 focus:ring-offset-green-50':
                  deleteTeacherSuccess.value,
                'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-red-600 focus:ring-offset-red-50':
                  !deleteTeacherSuccess.value,
              }),
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (showTeacherDeleteNotification.value = false))
                }, [
                  _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t(
                  deleteTeacherSuccess.value
                    ? "internal_tools.success.btnClose"
                    : "internal_tools.error.btnClose"
                )), 1),
                  _createVNode(_unref(XMarkIcon), {
                    class: "h-5 w-5",
                    "aria-hidden": "true"
                  })
                ], 2)
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})